module.exports = __webpack_public_path__ + "static/media/nvidia-logo-big.c1142114.jpg";